<app-navbar />
<div class="mt-18 bg-[#f0f0f0]">
  <router-outlet />
</div>
<app-footer />